/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! AI Conversion Doctor — viewer.
 *  /diagnose -> audience health + ranked blockers/opportunities ; /get?id=<vid> -> one visitor.
 *  Talks through the app's GS.api ({ok,status,data}). Deep-linkable via ?id=<vid>.
 */
(function () {
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["conversion-doctor"] = "1.0.0"; } catch (e) {}
  if (window.__bcdWired) return; window.__bcdWired = 1;

  var root = document.querySelector('[data-cd="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-cd="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function hcol(h) { return h >= 60 ? "#1FA463" : (h >= 40 ? "#D97706" : "#DC2626"); }
  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }
  function iso(ms) { return new Date(ms).toISOString().slice(0, 10); }
  var RANGE = { from: iso(Date.now() - 30 * 86400000), to: iso(Date.now()) };
  function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
  function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
  function _rpPreset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
  var _RPL={label:null,preset:"30"};
  (function(){try{var s=JSON.parse(localStorage.getItem("gs_cd_range")||"null");if(s&&s.preset){var p=_rpPreset(+s.preset);RANGE.from=p.from;RANGE.to=p.to;_RPL.label=p.label;_RPL.preset=p.preset;}else if(s&&s.from&&s.to){RANGE.from=s.from;RANGE.to=s.to;_RPL.label=s.from+" \u2192 "+s.to;_RPL.preset=null;}}catch(e){}if(!_RPL.label){var d=_rpPreset(30);_RPL.label=d.label;}})();
  function _rpInit(){
    function _rpBtnLabel(menu,preset){if(!menu||!preset)return null;var b=menu.querySelector('.rm[data-preset="'+preset+'"]');return b?b.textContent.trim():null;}
    
    if(_RPL&&_RPL.preset){var _rp=_rpPreset(+_RPL.preset);_RPL.label=_rp.label;if(typeof RANGE!=="undefined"&&RANGE){RANGE.label=_rp.label;}}
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label");if(!btn||!menu)return;
    (function(){var _pp=(typeof RANGE!=="undefined"&&RANGE&&RANGE.preset)||(typeof _RPL!=="undefined"&&_RPL&&_RPL.preset);var _bl=_rpBtnLabel(menu,_pp);if(_bl){if(lab)lab.textContent=_bl;if(typeof RANGE!=="undefined"&&RANGE)RANGE.label=_bl;if(typeof _RPL!=="undefined"&&_RPL)_RPL.label=_bl;}})();
    if(lab&&_RPL.label)lab.textContent=_RPL.label;
    function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===_RPL.preset);});}
    btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=RANGE.from;if(ct)ct.value=RANGE.to;sync();}});
    document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
    function apply(o){ if(o&&o.preset){var _bl2=_rpBtnLabel(menu,o.preset);if(_bl2)o.label=_bl2;}RANGE.from=o.from;RANGE.to=o.to;_RPL.label=o.label;_RPL.preset=o.preset;if(lab)lab.textContent=o.label;try{localStorage.setItem("gs_cd_range",JSON.stringify({from:o.from,to:o.to,preset:o.preset}));}catch(e){}menu.style.display="none";loadDiagnose();}
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(_rpPreset(+b.getAttribute("data-preset")));});});
    var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
  }

  /* ---- audience ---- */
  function loadDiagnose() {
    GS.api("/plugin/conversion-doctor/diagnose?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      drawGauge(d.health || 0);
      q("hval").textContent = (d.health != null ? d.health : "—");
      q("hval").style.color = hcol(d.health || 0);
      q("hsub").textContent = "across " + num(d.visitors) + " visitor" + (d.visitors === 1 ? "" : "s");
      var bl = q("blockers"), op = q("opps");
      if (!d.visitors) { bl.innerHTML = '<div class="cd-empty">' + esc(d.note || TR('conver.f2.no_visitors_to_diagnose_in_this_ra')) + "</div>"; op.innerHTML = ""; return; }
      bl.innerHTML = (d.blockers || []).length ? d.blockers.map(function (x) { return findCard(x, "blocker"); }).join("") : '<div class="cd-empty">No blockers detected — healthy.</div>';
      op.innerHTML = (d.opportunities || []).length ? d.opportunities.map(function (x) { return findCard(x, "opportunity"); }).join("") : '<div class="cd-empty">'+TR('conver.f2.no_standout_opportunities_in_this_')+'</div>';
    });
  }
  function findCard(x, type) {
    return '<div class="cd-find ' + type + " " + esc(x.severity) + '">' +
      '<div class="cd-find-top"><span class="cd-find-title">' + esc(x.title) + "</span>" +
      '<span class="cd-sev ' + esc(x.severity) + '">' + esc(x.severity) + "</span>" +
      (x.affected != null ? '<span class="cd-affected">' + num(x.affected) + " visitors &middot; " + (x.share || 0) + "%</span>" : "") +
      "</div>" +
      '<div class="cd-find-detail">' + esc(x.detail) + "</div>" +
      '<div class="cd-fix"><span class="rx">Rx</span><span>' + esc(x.fix) + "</span></div>" +
      "</div>";
  }
  function drawGauge(h) {
    h = Math.max(0, Math.min(100, +h || 0));
    var cx = 60, cy = 60, r = 46, col = hcol(h);
    function pt(frac) { var ang = Math.PI * (1 - frac); return [cx + Math.cos(ang) * r, cy - Math.sin(ang) * r]; }
    var s = pt(0), e = pt(h / 100), full = pt(1);
    function arc(a, b, big) { return "M" + a[0].toFixed(1) + " " + a[1].toFixed(1) + " A" + r + " " + r + " 0 " + big + " 1 " + b[0].toFixed(1) + " " + b[1].toFixed(1); }
    q("gauge").innerHTML =
      '<path d="' + arc(s, full, 0) + '" fill="none" stroke="#E9EDF3" stroke-width="9" stroke-linecap="round"/>' +
      '<path d="' + arc(s, e, h > 50 ? 1 : 0) + '" fill="none" stroke="' + col + '" stroke-width="9" stroke-linecap="round"/>';
  }

  /* ---- one visitor ---- */
  function loadVisitor(vid) {
    if (!vid) return;
    var host = q("visitor");
    host.innerHTML = '<div class="cd-empty">Loading&hellip;</div>';
    GS.api("/plugin/conversion-doctor/get?" + siteParam() + "&id=" + encodeURIComponent(vid)).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      if (!d.summary) { host.innerHTML = '<div class="cd-empty">' + esc(d.note || TR('conver.f2.no_diagnosis_for_this_visitor_yet')) + "</div>"; return; }
      var ft = d.features || {};
      var parts = '<div class="cd-vsum">' + esc(d.summary) + "</div>" +
        '<div class="cd-vprop">propensity <b>' + (d.propensity || 0) + "</b> &middot; intent <b>" + (ft.intent || 0) + "</b> &middot; frustration <b>" + (ft.frustration || 0) + "</b> &middot; attention <b>" + (ft.attention || 0) + "</b></div>";
      var bl = d.blockers || [], op = d.opportunities || [];
      parts += '<div class="cd-findings">' +
        (bl.length ? bl.map(function (x) { return findCard(x, "blocker"); }).join("") : "") +
        (op.length ? op.map(function (x) { return findCard(x, "opportunity"); }).join("") : "") +
        (!bl.length && !op.length ? '<div class="cd-empty">'+TR('conver.f2.no_notable_blockers_or_opportuniti')+'</div>' : "") +
        "</div>";
      host.innerHTML = parts;
    });
  }

  ready(function () {
    var f = q("from"), t = q("to");
    _rpInit();
    var open = q("load"), vidIn = q("vid");
    if (open && vidIn) open.addEventListener("click", function () { loadVisitor(vidIn.value.trim()); });
    if (vidIn) vidIn.addEventListener("keydown", function (e) { if (e.key === TR('conver.g.enter')) loadVisitor(vidIn.value.trim()); });
    loadDiagnose();
    var id = new URLSearchParams(location.search).get("id");
    if (id) { if (vidIn) vidIn.value = id; loadVisitor(id); }
  });
})();
